module.exports = __webpack_public_path__ + "static/salma1-f7ccbfb21572bd6f856a24ce506f516f.png";